// extracted by mini-css-extract-plugin
export default {"amount":"ShowRaiseStartup_amount__CNAf6","color":"ShowRaiseStartup_color__3w-LG","disable":"ShowRaiseStartup_disable__DFSFM"};